export default __webpack_public_path__ + "static/media/Bronze_1_Rank.f744cd10.png";